import React, { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/store/hooks';
import { queryParams } from "src/helpers/UrlHelpers";
import { fetchRefunds } from "src/actions/callrecorder/refundsActions";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

import PageLayout from '../_partials/PageLayout';
import ListTable from "./_partials/_ListTable";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "src/componets/Wrapper";
import Filter from "src/componets/Filter";

const LIMIT = 42;
const DEFAULT_ORDER_BY = 'refunded_at';

const NAV_ITEMS: {[index: number]: any} = {
  1: { id: 1, name: 'iOS',      url: callrecorderUrls.refundsPath({ order_by: DEFAULT_ORDER_BY, platform: 'ios' }) },
  2: { id: 2, name: 'Android',  url: callrecorderUrls.refundsPath({ order_by: DEFAULT_ORDER_BY, platform: 'android' }) },
};

const Refunds = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;
  const { pathname } = useLocation();

  const activeNavId = useMemo(() => {
    const platform = searchParams.get('platform');
    if (platform === 'ios') return 1;
    if (platform === 'android') return 2;
    return undefined;
  }, [searchParams]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['order_by', 'order', 'date_from', 'date_to', 'platform', 'user_id',
       'bundle_id', 'product_id', 'refund_reason', 'refund_source']
    );

    dispatch(fetchRefunds(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-refunds'>
      <PageHeader
        title='Refunds'
        navs={NAV_ITEMS}
        activeId={activeNavId}
        parent={{
          name: 'All',
          url: callrecorderUrls.refundsPath({ order_by: DEFAULT_ORDER_BY })
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Refunds;
